import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    bienes: [],
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    codigo: '',
    nombre: '',
    rubro: null,
    personal: null,
    incluirBienesPersonal: false,

    list: [],
    selectList: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.bienes = [];
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;
        
        state.codigo = '';
        state.nombre = '';
        state.rubro = null;
        state.personal = null;
        state.incluirBienesPersonal = false;
    },

    'INICIALIZAR'(state) {
        state.bienes = [];
    },
    'SET_BIENES'(state, bienes) {
        state.bienes = bienes;
    },
    'PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_LIST'(state) {
        state.list = [];
        state.selectList = [];
    },
    'SET_LIST'(state, list) {
        state.list = list;
        state.selectList = list.map(item => item.nombre.trim());
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },

    getBienes: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR')

            var queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;

            if (state.codigo != '') {
                queryString += '&codigo=' + state.codigo;
            }
            if (state.nombre != '') {
                queryString += '&nombre=' + state.nombre;
            }
            if (state.rubro) {
                if (state.rubro.id) {
                    if (state.rubro.id != 0) {
                        queryString += '&rubroId=' + state.rubro.id;
                    }
                }
            }
            if ((/true/i).test(state.incluirBienesPersonal)) {
                queryString += '&incluirBienesPersonal=true';

                if (state.personal) {
                    if (state.personal.id) {
                        if (state.personal.id != 0) {
                            queryString += '&personalId=' + state.personal.id;
                        }
                    }
                }
            }

            apiAxios.get('bienes' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('PAGINATION', params);
                    }
                    commit('SET_BIENES', res.data)

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    entregaPersonal({}, params) {
        return new Promise((resolve, reject) => {
            let bienMovimiento = {
                personalId: params.personalId,
                observaciones: params.observaciones
            }
    
            apiAxios.post(`bienes/${params.bienId}/personal/entrega`, bienMovimiento)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    devolucionPersonal({}, params) {
        return new Promise((resolve, reject) => {
            let bienMovimiento = {
                observaciones: params.observaciones
            }
    
            apiAxios.post(`bienes/${params.bienId}/personal/devolucion`, bienMovimiento)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    }
};

const getters = {
    getField,

    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}